import { Injectable } from '@angular/core';

@Injectable()
export class BrowserService {

    constructor() { }

    public isIE(): boolean {
        const ua = window.navigator.userAgent;
        if (ua.indexOf("MSIE") !== -1 || ua.indexOf("Trident") !== -1)
            return true;
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/browser.service.ts